import React from "react";
import { Link } from "react-router-dom";
import { Form, Button, message, Select } from "antd";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment-timezone";

import Step2 from "./ConsentStep2";
import Step3aPatient from "./ConsentStep3aPatient";
import ConsentMevoStep3aEmergency from "./ConsentStep3aEmergency";
import Step3aRegainedCapacity from "./ConsentStep3aRegainedCapacity";
import Step3b from "./ConsentStep3b";
import Step4 from "./ConsentStep4";

import { consentServices } from "../../services";
import { withNamespaces } from "react-i18next";
import { withParams } from "../../utils/url";
import {
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import { connect } from "react-redux";
import { withRouter } from "react-router";

const routes = require("../../routes.json");

const { Option } = Select;

export const ConsentTypes = {
  Patient_Electronic: "consent_patient_electronic",
  Patient_Paper: "consent_patient_paper",
  Patient_Email: "consent_patient_email",
  Patient_RegainedCapacity: "consent_patient_electronic_regained_capacity_form",
  Patient_RegainedCapacityPaper: "consent_regained_capacity_paper",
  Patient_EmailRegainedCapacity: "consent_regained_capacity_form_email",
  Surrogate_Electronic: "consent_surrogate_electronic",
  Surrogate_Paper: "consent_surrogate_paper",
  Surrogate_Email: "consent_surrogate_email",
  Emergency_Electronic: "consent_emergency_electronic",
  Emergency_Paper: "consent_emergency_paper",

  Patient_AfterDeferralPaper: "consent_participant_after_deferral_paper",
  Patient_AfterDeferralElectronic:
    "consent_participant_after_deferral_electronic",
  Patient_AfterDeferralEmail: "consent_participant_after_deferral_email",

  Surrogate_AfterDeferralPaper: "consent_surrogate_after_deferral_paper",
  Surrogate_AfterDeferralElectronic:
    "consent_surrogate_after_deferral_electronic",
  Surrogate_AfterDeferralEmail: "consent_surrogate_after_deferral_email",

  Patient_RegainedCapacityAfterDeferralPaper:
    "consent_patient_regained_capacity_after_deferral_paper",
  Patient_RegainedCapacityAfterDeferralElectronic:
    "consent_patient_regained_capacity_after_deferral_electronic",
  Patient_RegainedCapacityAfterDeferralEmail:
    "consent_patient_regained_capacity_after_deferral_email",

  Patient_ParticipantAssentPaper:
    "consent_participant_assent_paper",
  Patient_ParticipantAssentElectronic:
    "consent_participant_assent_electronic",
  Patient_ParticipantAssentEmail:
    "consent_participant_assent_email",

  Patient_AssessmentOfUnderstandingPaper:
    "consent_assessment_of_understanding_paper",
  Patient_AssessmentOfUnderstandingElectronic:
    "consent_assessment_of_understanding_electronic",
  Patient_AssessmentOfUnderstandingEmail:
    "consent_assessment_of_understanding_email",

  Patient_DocumentationOfConsentPaper:
    "consent_documentation_of_consent_paper",
  Patient_DocumentationOfConsentElectronic:
    "consent_documentation_of_consent_electronic",
  Patient_DocumentationOfConsentEmail:
    "consent_documentation_of_consent_email",
};

export const ConsentTypesAlt = {
  consent_patient_form__electronic: "consent_patient_electronic",
  consent_patient_form__email: "consent_patient_email",
  consent_patient_form__paper: "consent_patient_paper",

  consent_surrogate__electronic: "consent_surrogate_electronic",
  consent_surrogate__email: "consent_surrogate_email",
  consent_surrogate__paper: "consent_surrogate_paper",

  consent_patient_regained_capacity_form__electronic: "consent_patient_electronic_regained_capacity_form",
  consent_patient_regained_capacity_form__email: "consent_regained_capacity_form_email",
  consent_patient_regained_capacity_form__paper: "consent_regained_capacity_paper",


  consent_emergency__electronic: "consent_emergency_electronic",
  consent_emergency__email: "consent_emergency_email",
  consent_emergency__paper: "consent_emergency_paper",

  participant_after_deferral__electronic: "consent_emergency_electronic",
  participant_after_deferral__email: "consent_participant_after_deferral_email",
  participant_after_deferral__paper: "consent_participant_after_deferral_paper",

  surrogate_after_deferral__electronic: "consent_surrogate_after_deferral_electronic",
  surrogate_after_deferral__email: "consent_surrogate_after_deferral_email",
  surrogate_after_deferral__paper: "consent_surrogate_after_deferral_paper",

  patient_regained_capacity_after_deferral__electronic: "consent_patient_regained_capacity_after_deferral_electronic",
  patient_regained_capacity_after_deferral__email: "consent_patient_regained_capacity_after_deferral_email",
  patient_regained_capacity_after_deferral__paper: "consent_patient_regained_capacity_after_deferral_paper",

  participant_assent__paper: "consent_participant_assent_paper",
  participant_assent__electronic: "consent_participant_assent_electronic",
  participant_assent__email: "consent_participant_assent_email",

  assessment_of_understanding__paper: "consent_assessment_of_understanding_paper",
  assessment_of_understanding__electronic: "consent_assessment_of_understanding_electronic",
  assessment_of_understanding__email: "consent_assessment_of_understanding_email",

  documentation_of_consent__paper: "consent_documentation_of_consent_paper",
  documentation_of_consent__electronic: "consent_documentation_of_consent_electronic",
  documentation_of_consent__email: "consent_documentation_of_consent_email",
};

const TempReverse = Object.entries(ConsentTypes).map(
   ([prop, propValue]) => { return [propValue, prop.split("_")[1]]; }
);
export const AltToConsentTypeMapping = Object.fromEntries(TempReverse);

class Consent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      currentStepPerson: "",
      consent_steps_timestamps: [],
      currentStep: "Step 2",
      step: {
        ...this.initialStep,
      },
      currentStepInt: 2,
    };
  }

  initialStep = {};

  componentDidMount() {
    if (this.props.token) {
      this.setState((state) => ({
        currentStepPerson: this.props.currentStepPerson,
        currentStep: "Step 3a",
        step: { ...state.step, ...this.props.step },
      }));
    }

    moment.tz.setDefault(
      this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
    );
  }

  normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    if (e.fileList.length > 1) {
      e.fileList.shift();
    }
    this.setState((state) => ({
      step: { ...state.step, fileList: e.fileList },
    }));

    return e && e.fileList;
  };

  normFileDc = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    if (e.fileList.length > 1) {
      e.fileList.shift();
    }
    this.setState((state) => ({
      step: { ...state.step, fileListDc: e.fileList },
    }));

    return e && e.fileList;
  };

  normFileWithdraw = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    if (e.fileList.length > 1) {
      e.fileList.shift();
    }
    this.setState((state) => ({
      step: { ...state.step, fileListWithdraw: e.fileList },
    }));

    return e && e.fileList;
  };

  handleSubmitBuildForm = async (values) => {
    return new Promise(async (resolve) => {
      if (this.state.currentStep.includes("Step 3")) {
        this.setState((state) => ({
          consent_steps_timestamps: [
            ...state.consent_steps_timestamps,
            {
              name: "step_4",
              datetime: moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            },
          ],
        }));
      }

      if (values["dateOfBirth"]) {
        values["dateOfBirth"] = moment
          .utc(values["dateOfBirth"], "YYYY-MM-DD")
          .format("YYYY-MM-DD");
      }

      this.setState(
        (state) => ({
          step: { ...state.step, ...this.normalizeValues(values) },
        }),
        async () => {
          const {
            currentStep,
            step: { consentMethodType, consentPersonType },
            currentStepPerson,
          } = this.state;

          if (
            currentStep === "Step 3a" &&
            consentMethodType === "Electronic" &&
            currentStepPerson === "Investigator"
          ) {
            this.setState((state) => ({
              currentStepInt: 3,
              currentStep: "Step 3a",
              step: { ...state.step },
              currentStepPerson: consentPersonType,
            }));
            resolve();
          }

          if (currentStep === "Step 3a") {
            await this.sendForm(this.normalizeValues({...values, who_is_collecting_consent: this.state.step.who_is_collecting_consent}));
          }

          resolve();
        }
      );
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        if (this.state.currentStep.includes("Step 2")) {
          this.setState({
            consent_steps_timestamps: [
              {
                name: "step_3",
                datetime: moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              },
            ],
          });
        }

        if (this.state.currentStep.includes("Step 3")) {
          this.setState((state) => ({
            consent_steps_timestamps: [
              ...state.consent_steps_timestamps,
              {
                name: "step_4",
                datetime: moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              },
            ],
          }));
        }

        if (values["dateOfBirth"]) {
          values["dateOfBirth"] = moment
            .utc(values["dateOfBirth"], "YYYY-MM-DD")
            .format("YYYY-MM-DD");
        }

        this.setState(
          (state) => ({
            step: { ...state.step, ...this.normalizeValues(values) },
          }),
          async () => {
            let {
              currentStep,
              step: { consentMethodType, consentPersonType },
              currentStepPerson,
            } = this.state;

            if (currentStep === "Step 2") {
              this.setState({ loading: true });
              await this.props.sendStep2({
                "currentStep": "Step 2",
                "currentStepInt": 2,
                "subjectID": this.props.step.subjectID,
                "password": this.props.step.password,
                "siteID": this.props.step.siteID,
                "consent_type": get(ConsentTypes, `${this.state.step.consentPersonType}_${this.state.step.consentMethodType}`, get(ConsentTypesAlt, this.state.step.consentMethodType)),
                "languageCode": get(this.state.step, 'languageCode', null),
                "who_is_collecting_consent": this.state.step.who_is_collecting_consent
              });
              let isAltConsentType = get(ConsentTypesAlt, this.state.step.consentMethodType);
              if (isAltConsentType){
                consentMethodType = get(AltToConsentTypeMapping, isAltConsentType);
                this.state.step.consentMethodType = consentMethodType;
              }
              this.setState({ loading: false, consentMethodType: consentMethodType});
              console.log("consentMethodType ", consentMethodType);
              if (
                [
                  "Electronic",
                  "Email",
                  "AfterDeferralElectronic",
                  "AfterDeferralEmail",
                ].includes(consentMethodType) &&
                !currentStepPerson
              ) {
                this.setState((state) => ({
                  currentStepInt: 3,
                  currentStep: "Step 3a",
                  step: { ...state.step },
                  currentStepPerson: consentPersonType,
                }));
              }

              if (
                [
                  "RegainedCapacity",
                  "WithdrawConsentElectronic",
                  "EmailRegainedCapacity",
                  "WithdrawConsentEmail",
                  "RegainedCapacityAfterDeferralElectronic",
                  "RegainedCapacityAfterDeferralEmail",
                  "ParticipantAssentElectronic",
                  "ParticipantAssentEmail",
                  "AssessmentOfUnderstandingElectronic",
                  "AssessmentOfUnderstandingEmail",
                  "DocumentationOfConsentElectronic",
                  "DocumentationOfConsentEmail",
                ].includes(consentMethodType)
              ) {
                this.setState((state) => ({
                  currentStepInt: 3,
                  currentStep: "Step 3a",
                  step: { ...state.step },
                  currentStepPerson: consentPersonType,
                }));
              }

              if (
                [
                  "Paper",
                  "WithdrawConsentPaper",
                  "RegainedCapacityPaper",
                  "AfterDeferralPaper",
                  "RegainedCapacityAfterDeferralPaper",
                  "ParticipantAssentPaper",
                  "AssessmentOfUnderstandingPaper",
                  "DocumentationOfConsentPaper",
                ].includes(consentMethodType)
              ) {
                this.setState((state) => ({
                  currentStepInt: 3,
                  currentStep: "Step 3b",
                  step: { ...state.step },
                }));
              }

              return;
            }

            if (
              currentStep === "Step 3a" &&
              consentMethodType === "Electronic" &&
              currentStepPerson === "Investigator"
            ) {
              this.setState((state) => ({
                currentStepInt: 3,
                currentStep: "Step 3a",
                step: { ...state.step },
                currentStepPerson: consentPersonType,
              }));
              return;
            }

            if (
              currentStep === "Step 3a" &&
              consentMethodType === "Email" &&
              currentStepPerson === "Investigator"
            ) {
              await this.sendForm(this.normalizeValues(values));
              return;
            }

            if (currentStep === "Step 3a") {
              await this.sendForm(this.normalizeValues(values));
            }

            if (
              currentStep === "Step 3b" &&
              ![
                "Paper",
                "AfterDeferralPaper",
                "RegainedCapacityAfterDeferralPaper",
                "ParticipantAssentPaper",
                "AssessmentOfUnderstandingPaper",
                "DocumentationOfConsentPaper",
              ].includes(consentMethodType)
            ) {
              try {
                await this.sendForm(
                  this.normalizeValues(values),
                  values["consentFile"]
                );
              } catch (e) {
                if (e.response) {
                  message.error(get(e, "response.data.error", "Error"), 5);
                }
              }
            }

            if (
              currentStep === "Step 3b" &&
              [
                "Paper",
                "AfterDeferralPaper",
                "RegainedCapacityAfterDeferralPaper",
                "ParticipantAssentPaper",
                "AssessmentOfUnderstandingPaper",
                "DocumentationOfConsentPaper",
              ].includes(consentMethodType)
            ) {
              try {
                await this.sendForm(
                  this.normalizeValues(values),
                  values["consentFile"],
                  values["consentFileDc"],
                  values["consentFileWithdraw"]
                );
              } catch (e) {
                if (e.response) {
                  message.error(get(e, "response.data.error", "Error"), 5);
                }
              }
            }
          }
        );
      }
    });
  };

  normalizeValues = (values) => {
    const normalizedValues = { ...values };
    const timestamp = Date.now();
    for (const key in values) {
      if (moment.isMoment(values[key])) {
        const date = cloneDeep(values[key]);
        normalizedValues[key] = date.format("YYYY-MM-DDTHH:mm");
        // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
      }
      if (values[key] === "true") {
        normalizedValues[key] = true;
      }
      if (values[key] === "false") {
        normalizedValues[key] = false;
      }

      if (key.includes('___date_time_delta')) {
        normalizedValues[key] = (timestamp - values[key]) / 1000;
      }
    }

    return normalizedValues;
  };

  sendForm = async (values, file, fileDc = null, fileWithdraw = null) => {
    const { token } = this.props;
    this.setState({ loading: true });

    const propsFormValues = {
      siteID: this.props.step.siteID,
      subjectID: this.props.step.subjectID,
      userID: this.props.step.userID,
      languageCode: this.state.step.languageCode || this.props.step.languageCode,
    };

    const formData = {
      ...this.state.step,
      ...propsFormValues,
      consent_type:
        ConsentTypes[
          `${this.state.step.consentPersonType}_${this.state.step.consentMethodType}`
        ],
      consent_steps_timestamps: !this.state.step.consentMethodType.includes("Paper")
        ? this.state.consent_steps_timestamps
        : undefined,
      consentMethodType: undefined,
      consentPersonType: undefined,
    };

    try {
      if (this.state.step.consent_date_date) {
        const consent_date = moment(
          `${moment(this.state.step.consent_date_date).format(
            "YYYY-MM-DD"
          )}T${moment(this.state.step.consent_date_time).format("HH:mm")}`
        )
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");

        formData.consent_date_date = undefined;
        formData.consent_date_time = undefined;
        formData.consent_date = consent_date;
      }

      if (token) {
        const { data } = await consentServices.confirmConsentWorkflowV2_1ByToken(
          token,
          values
        );
        this.setState((state) => ({
          currentStep: "Step 4",
          step: { ...state.step, ...data },
        }));
      } else {
        const { data } = await consentServices.createWorkflowV2_1(
          formData,
          file,
          fileDc,
          fileWithdraw
        );
        this.setState((state) => ({
          currentStep: "Step 4",
          step: { ...state.step, ...data },
        }));
      }
    } catch (e) {
      console.log(e);
      if (e.response) {
        message.error(
          JSON.stringify(
            get(e, "response.data.error", get(e, "response", "Error"))
          ),
          5
        );
      }
    }

    this.setState({ loading: false });
  };

  onPrev = () => {
    const { currentStep } = this.state;

    if (currentStep === "Step 2") {
      this.props.history.push("/admin/consent");
    } else if (["Step 3a", "Step 3b"].includes(currentStep)) {
      this.setState({
        step: { ...this.initialStep },
        currentStep: "Step 2",
        currentStepPerson: "",
      });
    }
  };

  render() {
    const {
      loading,
      currentStep,
      step: { consentMethodType, consentPersonType },
      step,
      currentStepPerson,
    } = this.state;
    const { token } = this.props;
    window.form = this.props.form;

    const queryParams = new URLSearchParams(this.props.location.search);
    return (
      <div>
        <h2>
          {this.props.i18n.t("NamespaceConsent:Consent")} - {this.state.currentStep}
        </h2>

        {currentStep === "Step 3a" &&
        [
          "Electronic",
          "Email",
          "AfterDeferralElectronic",
          "AfterDeferralEmail",
          "AssessmentOfUnderstandingElectronic",
          "AssessmentOfUnderstandingEmail",
          "DocumentationOfConsentElectronic",
          "DocumentationOfConsentEmail",
        ].includes(consentMethodType) &&
        ["Patient", "Surrogate"].includes(currentStepPerson) && (
          <div>
            <Step3aPatient
              {...this.props.step}
              form={this.props.form}
              {...this.state.step}
              token={token}
              handleSubmitBuildForm={this.handleSubmitBuildForm}
              backStep={<div>{(currentStep === "Step 2" ||
                currentStep === "Step 3a" ||
                currentStep === "Step 3b") &&
              !token && (
                <Button
                  type="secondary"
                  size="large"
                  htmlType="button"
                  onClick={this.onPrev}
                >
                  {this.props.i18n.t("Back")}
                </Button>
              )}</div>}
            />
          </div>
        )}

        {currentStep === "Step 3a" &&
        currentStepPerson === "Emergency" &&
        ["Electronic", "Email"].includes(consentMethodType) && (
            <div>
              <ConsentMevoStep3aEmergency
                {...this.props.step}
                form={this.props.form}
                {...this.state.step}
                token={token}
                handleSubmitBuildForm={this.handleSubmitBuildForm}
                backStep={<div>{(currentStep === "Step 2" ||
                    currentStep === "Step 3a" ||
                    currentStep === "Step 3b") &&
                  !token && (
                    <Button
                      type="secondary"
                      size="large"
                      htmlType="button"
                      onClick={this.onPrev}
                    >
                      {this.props.i18n.t("Back")}
                    </Button>
                  )}</div>}
              />
            </div>
          )}

        {currentStep === "Step 3a" &&
        [
          "RegainedCapacity",
          "EmailRegainedCapacity",
          "RegainedCapacityAfterDeferralElectronic",
          "RegainedCapacityAfterDeferralEmail",
          "ParticipantAssentElectronic",
          "ParticipantAssentEmail",
        ].includes(consentMethodType) && (
            <div>
              <Step3aRegainedCapacity
                {...this.props.step}
                form={this.props.form}
                {...this.state.step}
                token={token}
                handleSubmitBuildForm={this.handleSubmitBuildForm}
                backStep={<div>{(currentStep === "Step 2" ||
                    currentStep === "Step 3a" ||
                    currentStep === "Step 3b") &&
                  !token && (
                    <Button
                      type="secondary"
                      size="large"
                      htmlType="button"
                      onClick={this.onPrev}
                    >
                      {this.props.i18n.t("Back")}
                    </Button>
                  )}</div>}
              />
            </div>
          )}

        <Form onSubmit={this.handleSubmit} className="main-form">
          {currentStep === "Step 2" && (
            <Step2
              {...this.props.step}
              form={this.props.form}
              {...this.state.step}
            />
          )}

          {currentStep === "Step 3b" &&
            ![
              "Paper",
              "AfterDeferralPaper",
              "RegainedCapacityAfterDeferralPaper",
              "ParticipantAssentPaper",
              "AssessmentOfUnderstandingPaper",
              "DocumentationOfConsentPaper",
            ].includes(consentMethodType) && (
              <Step3b
                {...this.props.step}
                form={this.props.form}
                {...this.state.step}
                normFile={this.normFile}
              />
            )}

          {currentStep === "Step 3b" &&
            [
              "Paper",
              "AfterDeferralPaper",
              "RegainedCapacityAfterDeferralPaper",
              "ParticipantAssentPaper",
              "AssessmentOfUnderstandingPaper",
              "DocumentationOfConsentPaper",
            ].includes(consentMethodType) && (
              <Step3b
                {...this.props.step}
                form={this.props.form}
                {...this.state.step}
                normFile={this.normFile}
                normFileDc={this.normFileDc}
                normFileWithdraw={this.normFileWithdraw}
              />
            )}

          {currentStep === "Step 4" && (
            <div>
              <Step4 {...this.props.step} {...this.state.step} token={token} />

              {this.props.step.consentRandomization && (
                <div>
                  {queryParams.get("obtainConsent") === "true" ? (
                    <div>
                      <div>
                        <a
                          href={withParams(routes.admin.consentRandomization, {
                            obtainConsent: "true",
                          })}
                        >
                          <Button
                            type="primary"
                            htmlType="button"
                            size="default"
                          >
                            {this.props.i18n.t("NamespaceConsent:Obtain new consent")}
                          </Button>
                        </a>
                        <div style={{ marginTop: "10px" }}>
                          <a href={routes.admin.unassignedConsentRecords}>
                            <Button htmlType="button" size="default">
                              {this.props.i18n.t("NamespaceConsent:View Unassigned Consent Records")}
                            </Button>
                          </a>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {!consentMethodType.includes('Email') && <a
                        href={withParams(routes.admin.randomize, {
                          consentRecordID: this.state.step.consentRecordID,
                          siteCode: get(this.state.step, "details.site.code"),
                          subjectCode: get(this.state.step, "subjectID", undefined),
                        })}
                      >
                        <Button type="primary" htmlType="button" size="default">
                            {this.props.i18n.t("NamespaceConsent:Randomize")}
                        </Button>
                      </a>}
                      <div style={{ marginTop: "10px" }}>
                        <a href={routes.admin.dashboard}>
                          <Button htmlType="button" size="default">
                            {this.props.i18n.t("NamespaceConsent:Randomize later")}
                          </Button>
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {currentStep !== "Step 4" && currentStep !== 'Step 3a' && (
            <div className="action-wrapper">
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={loading}
              >
                {currentStep === "Step 1" ||
                currentStep === "Step 2" ||
                ["Investigator", "Patient", "Emergency", "Surrogate"].includes(
                  currentStepPerson
                )
                  ? this.props.i18n.t("Next")
                  : this.props.i18n.t("Submit")}
              </Button>
              {(currentStep === "Step 2" ||
                currentStep === "Step 3a" ||
                currentStep === "Step 3b") &&
                !token && (
                  <Button
                    type="secondary"
                    size="large"
                    htmlType="button"
                    onClick={this.onPrev}
                  >
                    {this.props.i18n.t("Back")}
                  </Button>
                )}
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

const ConsentForm = Form.create()(
  withRouter(withNamespaces()(connect(mapStateToProps)(Consent)))
);

export default ConsentForm;



// WEBPACK FOOTER //
// ./src/components/ConsentTypeWorkflowV2_1/ConsentForm.js